import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Menu, MenuAdd, MenuEdit, MenuItem } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiListAppVersion } from '../../../../../../api-new/state/config'
import { IconActivityLog, IconDelete, IconList, IconRecycle } from '../../../../../../shared/icon/icon'
import { useAuditCapabilities } from '../../../../../../shared/audit/use-audit-capabilities'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnMenu, ColumnText, ColumnYesNo } from '../../../../../../shared/table-builder/table-columns'

export const AppVersionList = () => {
  const { appID, appStoreID } = useParamsInt()

  const apiListAppVersion = useApiListAppVersion()

  const roleSysApp = useRoleSysApp()
  const caps = useAuditCapabilities()

  const handleReady = () => apiListAppVersion.get(`${appStoreID}/store`)
  const handleDestroyed = () => apiListAppVersion.init()

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add" to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/add`} show={roleSysApp.accessCreate} />

      <MenuItem Icon={IconRecycle} text="recycle" to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/recycle`} show={roleSysApp.accessDelete} />
      <MenuItem Icon={IconActivityLog} text="audit log" to="/admin/audit-log?type=app_versions" show={caps.sysAuditLog} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Store versions">
        <CardFullHeightScrollY title="Store versions" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListAppVersion} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnText field="code" />
            <ColumnYesNo field="isRequired" header="Required" />
            <ColumnYesNo field="isActive" header="Active" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/edit/${row.id}`} show={roleSysApp.accessUpdate} />
                  <MenuItem
                    Icon={IconDelete}
                    text="delete"
                    to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/edit/${row.id}/delete`}
                    show={roleSysApp.accessDelete}
                  />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
